import React from 'react';
import Image from 'next/image';

import { IImageModel } from 'models';

export enum Layout {
  fill = 'fill',
  intrinsic = 'intrinsic',
  responsive = 'responsive',
  fixed = 'fixed',
}

export enum ObjectFit {
  fill = 'fill',
  contain = 'contain',
  cover = 'cover',
  none = 'none',
  scaleDown = 'scale-down',
}

type Props = {
  image: IImageModel;
  layout?: Layout;
  objectFit?: ObjectFit;
};

export default function ImageRender({ image, layout, objectFit }: Props) {
  if (!image) return <></>;

  return (
    <Image
      src={image.url}
      layout={layout ?? 'responsive'}
      width={image.width}
      height={image.height}
      priority={true}
      objectFit={objectFit ?? 'contain'}
      alt={image.caption}
    />
  );
}
